/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * Analyzer API
 * Analyzer API gateway
 * OpenAPI spec version: 1.0.0
 */

export type QuestionnaireStatus = (typeof QuestionnaireStatus)[keyof typeof QuestionnaireStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuestionnaireStatus = {
  new: "new",
  evaluated: "evaluated",
  evaluated_outdated: "evaluated_outdated",
  expired: "expired",
  questions_modified: "questions_modified",
  nsure_questions_changed: "nsure_questions_changed",
} as const;
